/* sheesha variant "See more" — collapse long variant option lists (pills/swatches)
   to a fade with a See more/See less toggle, so many-variant products don't push
   the buy buttons far down. Document-level so it survives Shopify variant re-renders. */
(function () {
  var PILL_LIMIT = 6;
  var SWATCH_LIMIT = 8;
  var idCounter = 0;

  function enhance() {
    var fields = document.querySelectorAll('.product-form__input--pill, .product-form__input--swatch');
    fields.forEach(function (fs) {
      if (fs.dataset.sheeshaVsm) return;
      var opts = fs.querySelectorAll('input[type="radio"], label');
      var isSwatch = fs.classList.contains('product-form__input--swatch');
      var limit = isSwatch ? SWATCH_LIMIT : PILL_LIMIT;
      var count = fs.querySelectorAll('input[type="radio"]').length;
      if (count <= limit) return;

      fs.dataset.sheeshaVsm = '1';
      fs.classList.add('sheesha-vsm', 'sheesha-vsm--collapsed');
      if (!fs.id) fs.id = 'sheesha-vsm-' + (++idCounter);

      if (fs.nextElementSibling && fs.nextElementSibling.classList.contains('sheesha-vsm__toggle')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sheesha-vsm__toggle';
      btn.textContent = 'See more (' + count + ')';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', fs.id);
      btn.addEventListener('click', function () {
        var collapsed = fs.classList.toggle('sheesha-vsm--collapsed');
        btn.textContent = collapsed ? 'See more (' + count + ')' : 'See less';
        btn.setAttribute('aria-expanded', String(!collapsed));
      });
      fs.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState !== 'loading') enhance();
  else document.addEventListener('DOMContentLoaded', enhance);
  // Re-run after Shopify re-renders the variant picker on selection change.
  document.addEventListener('change', function () { setTimeout(enhance, 60); });
})();
